import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = (theme) => ({
  container: {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#ddd',
    margin: '3px 0',
  },
  progress: {
    color: '#fff',
    fontWeight: 400,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
      height: 21,
    },
  },
  value: {
    position: 'absolute',
    textShadow: '1px 1px 1px #666',
    padding: '0 5px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      textShadow: '1px 1px 1px #666',
    },
  },
})

class ProgressBar extends React.Component {
  state = {
    value: 0,
  }
  componentDidMount = () => {
    const { value } = this.props
    if (value) {
      return this.setState({ value })
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const { value } = nextProps
    if (value !== this.props.value) {
      return this.setState({ value })
    }
  }

  toPercentage = (value) => {
    if (typeof value === 'number') {
      return `${value}%`
    }
  }

  getColor = (value) => {
    const { theme } = this.props
    let color

    if (value < 60) color = theme.palette.error.main
    else if (value >= 60 && value < 80) color = theme.palette.warning
    else if (value >= 80) color = '#56af78'

    return color
  }

  render() {
    const { classes, label } = this.props
    const { state } = this

    return (
      <div className={classes.container}>
        <Typography
          className={classes.progress}
          style={{
            width: this.toPercentage(state.value),
            backgroundColor: this.getColor(state.value),
          }}
        >
          <span className={classes.value}>
            {label} {this.toPercentage(state.value)}
          </span>
        </Typography>
      </div>
    )
  }
}

ProgressBar.defaultProps = {
  value: 0,
}

ProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
}

export default withStyles(styles, { withTheme: true })(ProgressBar)



// WEBPACK FOOTER //
// ./src/components/Reviewpage/ProgressBar.js